import {
  BasePageModel,
  basePageToLocal,
  basePageToServer
} from '@interface/index';

export interface TPUpdateFuncArgumentConfig {
  nextTpData?: TrainingPhraseConfig[];
  nextDelTp?: TrainingPhraseConfig;
}

export const TrainingPhraseOwnerType = {
  INTENT: 'intent',
  COMPOSITE: 'composite',
  ENTITY: 'entity',
  ATTRIBUTE: 'attribute',
  RESPONSE: 'response',
  CONFIRMATION: 'confrimation',
  CLOSURE: 'closure',
  SUGGESTION: 'suggestion',
  COMPANION: 'companion'
};

export const TrainingPhraseType = {
  CONFIRM_YES: 'confirm_yes',
  CONFIRM_NO: 'confirm_no',
  PROMPT_ANSWER: 'prompt_answer',
  SLOT_VALUE: 'slot_value',
  BOOLEAN_YES: 'boolean_yes',
  BOOLEAN_NO: 'boolean_no',
  MULTI_NO: 'multi_value_no',
  FRAME_QUERY: 'frame_query',
  FRAME_NEGATIVE: 'frame_negative',
  ENTAILMENT: 'entailment',
  ABORT: 'abort',
  ABORT_NEGATIVE: 'abort_negative',
  ABORT_ENTAILMENT: 'abort_entailment',
  DONT_CARE: 'dont_care',
  SLOT_UPDATE: 'slot_update',
  SLOT_APPEND: 'slot_append',
  SLOT_DELETE: 'slot_delete',
  BOOLEAN_GATE_YES: 'boolean_gate_yes',
  BOOLEAN_GATE_NO: 'boolean_gate_no',
  RESPONSE_CONFIRM_YES: 'response_confirm_yes',
  RESPONSE_CONFIRM_NO: 'response_confirm_no',
  QUERY_TRIGGER: 'query_trigger',
  COMPANION_TRIGGER: 'companion_trigger',
  SUGGESTION_TRIGGER: 'suggestion_trigger',
  PRONOUN: 'pronoun'
};

export interface TrainingPhraseConfig extends BasePageModel {
  kind: 'TrainingPhraseConfig';
  trainingPhrase: string;
  phraseType: string;
  label?: string;
  masterSelf?: TrainingPhraseMaster;
}

interface TrainingPhraseMaster {
  trainingPhrase: string;
}

export const TPType = {
  ADD: 'add',
  REPLACE: 'replace',
  DELETED: 'deleted'
};


export function trainingPhraseToLocal(tp: any): TrainingPhraseConfig {

  const tpItemPayload: TrainingPhraseConfig = {
    ...basePageToLocal(tp),
    trainingPhrase: tp.training_phrase,
    phraseType: tp.phrase_type,
    kind: 'TrainingPhraseConfig',
    label: tp.label,
    masterSelf: tp.master_self && trainingPhraseToLocal(tp.master_self)
  };

  return tpItemPayload;
}

export const trainingPhraseToServer = (data: TrainingPhraseConfig) => {

  const payload = {
    ...basePageToServer(data),
    frame_id: data.frameId,
    owner_id: data.ownerId,
    id: data.id,
    phrase_type: data.phraseType,
    owner_type: data.ownerType,
    training_phrase: data.trainingPhrase,
    label: data.label,
    to_be_deleted: data.toBeDeleted
  };

  if (!payload.id || !payload.id.length) {
    delete payload.id;
  }

  return payload;
};
